import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useParams } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ProblemPage from "./pages/ProblemPage";
import ProblemsList from "./pages/ProblemsList";
import Register from "./components/Register";
import AddProblemPage from "./pages/AddProblemPage";
import AccountPage from "./pages/AccountPage";
import NavBarV2 from "./components/NavBarV2";
import ContactUs from "./components/ContactUs";
import ProblemOfTheDay from "./pages/ProblemOfTheDay";
import Feedback from "./components/Feedback";
import Entry from "./components/Entry";
import Membership from "./pages/Membership";
import NewProblemPage from "./pages/NewProblemPage";
import OAuthSuccess from "./pages/OAuthSuccess"; // adjust path as needed
import "./App.css";
import LearningPaths from "./pages/LearningPaths";
import LearningPathPage from "./pages/LearningPathPage";
import ProtectedRoute from "./components/ProtectedRoute";
import WhyBlockcode from "./pages/WhyBlockcode";
import PrivateRoute from "./components/PrivateRoute";
import Success from "./pages/Success";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Legal from "./pages/Legal";
import AboutUs from "./pages/AboutUs";
import ComingSoon from "./pages/ComingSoon";
import MobileWarning from "./components/MobileWarning";
import ResetScrollContainer from "./components/ResetScrollContainer";
import Leaderboard from "./components/Leaderboard";

const HomeWrapper = ({ isLoggedIn }) => {
  if (isLoggedIn === null) return null;
  return isLoggedIn ? <HomePage /> : <Navigate to="/entry" replace />;
};

const ProblemAccessWrapper = ({ isLoggedIn, hideNav, setHideNav }) => {
  const { id } = useParams();

  // Allow anyone to access problem 476
  if (id === "476" || isLoggedIn) {
    return <ProblemPage hideNav={hideNav} setHideNav={setHideNav} />;
  } else {
    return <Navigate to="/entry" replace />;
  }
};

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [hideNav, setHideNav] = useState(false); // ⬅️ moved here properly
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // tweak as needed
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    setIsLoggedIn(!!token);
  }, []);

  if (isMobile) {
    return <MobileWarning />;
  }
  if (isLoggedIn === null) return null;

  return (
    <Router>
      <div className="app-container">
        <canvas
          id="confetti-canvas"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            zIndex: 9999,
          }}
        />

        <NavBarV2 isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />

        <ResetScrollContainer />

        <div className="content-container">
          <Routes>
            <Route path="/" element={<HomeWrapper isLoggedIn={isLoggedIn} />} />
            <Route path="/oauth-success" element={<OAuthSuccess />} />
            <Route path="/entry" element={<Entry isLoggedIn={isLoggedIn} />} />
            <Route
              path="/problems"
              element={
                <PrivateRoute>
                  <ProblemsList />
                </PrivateRoute>
              }
            />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/leaderboard" element={<Leaderboard />} />

            <Route
              path="/create-problem"
              element={
                // <PrivateRoute allowedRoles={["PAID_USER", "PREMIUM_USER", "ADMIN"]}>
                <PrivateRoute>
                  <AddProblemPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/about-us"
              element={
                <PrivateRoute>
                  <AboutUs />
                </PrivateRoute>
              }
            />

            <Route
              path="/coming-soon"
              element={
                <PrivateRoute>
                  <ComingSoon />
                </PrivateRoute>
              }
            />

            <Route
              path="/why-blockcode"
              element={
                <PrivateRoute>
                  <WhyBlockcode />
                </PrivateRoute>
              }
            />
            <Route
              path="/problems/:id"
              element={
                <ProblemAccessWrapper
                  isLoggedIn={isLoggedIn}
                  hideNav={hideNav}
                  setHideNav={setHideNav}
                />
              }
            />
            <Route path="/register" element={<Register />} />
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <AccountPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/contactus"
              element={
                <PrivateRoute>
                  <ContactUs />
                </PrivateRoute>
              }
            />
            <Route
              path="/problem-of-the-day"
              element={
                <PrivateRoute>
                  <ProblemOfTheDay />
                </PrivateRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <PrivateRoute>
                  <Feedback />
                </PrivateRoute>
              }
            />
            <Route
              path="/membership"
              element={
                <PrivateRoute>
                  <Membership />
                </PrivateRoute>
              }
            />
            <Route
              path="/problems2/:id"
              element={
                <PrivateRoute>
                  <NewProblemPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/learning-paths"
              element={
                <PrivateRoute>
                  <LearningPaths />
                </PrivateRoute>
              }
            />
            <Route
              path="/learning-paths/:pathId"
              element={
                <PrivateRoute>
                  <LearningPathPage />
                </PrivateRoute>
              }
            />
            <Route path="/success" element={<Success />} />
          </Routes>
        </div>

        {/* <Footer /> */}
      </div>
    </Router>
  );
}

export default App;
